import { JetView } from 'webix-jet';
import { devConfig, profile } from 'config/config';

/**
 * Class representing the filter for player account reports.
 * @extends JetView
 */
export default class FilterPlayerAccountReports extends JetView {
    /**
     * Configures the UI components of the filter.
     * @returns {Object} The configuration object for the filter UI.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            id: 'a1',
            margin: 5,
            rows: [
                {
                    responsive: 'a1',
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            id: 'Datepicker',
                            name: 'Datepicker',
                            view: 'text',
                            css: 'reportrange',
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'), // Default date range
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            id: 'Date',
                            name: 'Date',
                            view: 'datepicker',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'), // Default date
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Limit date selection to today
                                },
                            },
                        },
                        {
                            id: 'PlayerId',
                            name: 'PlayerId',
                            view: 'text',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Jugador'),
                            labelPosition: 'top',
                            placeholder: _('ID'),
                        },
                        {
                            view: 'richselect',
                            name: 'DocumentType',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('Tipo Documento'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: '0', // Default value for document type
                            options: [
                                { id: '0', value: _('Todos') },
                                { id: '1', value: _('DNI') },
                                { id: '2', value: _('Cédula de extranjería') },
                                { id: '3', value: _('Pasaporte') },
                            ],
                        },
                        {
                            id: 'DocumentNumber',
                            name: 'DocumentNumber',
                            view: 'text',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('Numero del documento'),
                            labelPosition: 'top',
                            placeholder: _('Numero'),
                        },
                    ],
                },
                {
                    responsive: 'a1',
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            id: 'PlayerName',
                            name: 'PlayerName',
                            view: 'text',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('Nombre del jugador'),
                            labelPosition: 'top',
                            placeholder: _('Nombre'),
                        },
                        {},
                        {},
                        {},
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };
        const buttons = {
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button
                    width: screen == 'small' ? 0 : 100,
                    minWidth: 200,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                        $$('CountrySelect').setValue($$('myForm').getCleanValues().CountrySelect);
                        $$('Datepicker').setValue(''); // Clear datepicker
                    },
                },
                {
                    id: 'consultDesk',
                    view: 'button',
                    value: _('Consultar'), // Consult button
                    hotkey: 'enter',
                    type: 'form',
                    width: screen == 'small' ? 0 : 100,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get filter values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country if applicable
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date if not needed
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker if needed
                            }
                        }
                        this.app.callEvent('playerAccount:filter', [
                            filterdata, // Trigger filter event with data
                        ]);
                        $$('b5').collapse(); // Collapse filter section
                        $$('a5').scrollTo(100, 0); // Scroll to specific position
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button for second form
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues()); // Reset second form values
                        $$('CountrySelect').setValue($$('myForm2').getCleanValues().CountrySelect);
                        $$('Datepicker').setValue(''); // Clear datepicker
                    },
                },
                {
                    id: 'consultDesk',
                    view: 'button',
                    value: _('Consultar'), // Consult button for second form
                    hotkey: 'enter',
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get filter values from second form
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country if applicable
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date if not needed
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker if needed
                            }
                        }
                        this.app.callEvent('playerAccount:filter', [
                            filterdata, // Trigger filter event with data
                        ]);
                    },
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            id: 'b5',
                            header: _('Filtros'), // Header for filters section
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Include upper section
            },
        };
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            modal: true,
            position: 'center',
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Popup title
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close popup
                        },
                    },
                ],
            },
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Include accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            id: 'myForm',
            view: 'form',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion section based on screen size
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide date input if not needed
                $$('Datepicker').show(); // Show datepicker
            } else {
                $$('Date').show(); // Show date input
                $$('Datepicker').hide(); // Hide datepicker
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
